"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var context_1 = require("./context");
var FileUploadDropArea_1 = __importDefault(require("./FileUploadDropArea"));
var FileUploadItemList_1 = __importDefault(require("./FileUploadItemList"));
var useFileListState_1 = __importDefault(require("./useFileListState"));
var componentsContainer = react_1.css({
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
});
var FileUpload = function (_a) {
    var disabled = _a.disabled, items = _a.items, multiple = _a.multiple, onChange = _a.onChange, _b = _a.showFileIcon, showFileIcon = _b === void 0 ? true : _b, uploadUserMessage = _a.uploadUserMessage, accept = _a.accept, validateFile = _a.validateFile;
    var fileUploader = context_1.useFileUploader();
    var _c = useFileListState_1.default({
        items: items,
        onChange: onChange,
        fileUploader: fileUploader,
        validateFile: validateFile,
    }), addFiles = _c.addFiles, removeItem = _c.removeItem, retryItem = _c.retryItem;
    return (react_1.jsx("div", { css: componentsContainer },
        multiple || !items.length ? (react_1.jsx(FileUploadDropArea_1.default, { accept: accept, disabled: disabled, uploadUserMessage: uploadUserMessage, multiple: multiple, addFiles: addFiles })) : null,
        items.length ? (react_1.jsx(FileUploadItemList_1.default, { items: items, showFileIcon: showFileIcon, removeItem: removeItem, retryItem: retryItem, disabled: disabled })) : null));
};
exports.default = FileUpload;
